/**
 * Dollars as typed into a money field: digits with at most two decimals (the empty string clears the field).
 * Money fields are text inputs filtered by this, not type="number": a focused number input steps its value on
 * mouse wheel and arrow keys (4000 -> 3999.9), silently changing the amount.
 */
export const DOLLAR_INPUT = /^\d*\.?\d{0,2}$/;
